import { createEffect } from '../utils/store';

export const setOrganizationDetails = createEffect('SET_ORGANIZATION_DETAILS');
export const setOrganizationCreated = createEffect('SET_ORGANIZATION_CREATED');
export const setOrganizationId = createEffect('SET_ORGANAZATION_ID');
export const setInvitedUserOrganizationId = createEffect(
  'SET_INVITED_USER_ORGANAZATION_ID',
);
export const setApplications = createEffect('SET_APPLICATIONS');
export const setCurrentApplication = createEffect('SET_CURRENT_APPLICATIONS');
export const setBillingDetails = createEffect('SET_BILLING_DETAILS');
export const setInvoices = createEffect('SET_INVOICES');
export const setPaymentSources = createEffect('SET_PAYMENT_SOURCES');
export const setPaymentSourcesError = createEffect('SET_PAYMENT_SOURCES_ERROR');
export const setDefaultAccountError = createEffect('SET_DEFAULT_ACCOUNT_ERROR');
export const setDiscounts = createEffect('SET_DISCOUNTS');
export const setUsers = createEffect('SET_USERS');
export const setContracts = createEffect('SET_CONTRACTS');
export const setProfile = createEffect('SET_PROFILE');
export const setUsageSummary = createEffect('SET_USAGE_SUMMARY');
export const addApplication = createEffect('ADD_APPLICATION');
export const setWebhooksEvents = createEffect('SET_WEBHOOKS_EVENTS');
export const removeApplication = createEffect('REMOVE_APPLICATION');
export const accountLoading = createEffect('ACCOUNT_LOADING');
export const setSecretKeyCommunication = createEffect(
  'SET_SECRET_KEY_COMMUNICATION',
);
export const resetSecretKeyCommunication = createEffect(
  'RESET_SECRET_KEY_COMMUNICATION',
);
export const setMediaSecretKeyCommunication = createEffect(
  'SET_MEDIA_SECRET_KEY_COMMUNICATION',
);
export const resetMediaSecretKeyCommunication = createEffect(
  'RESET_MEDIA_SECRET_KEY_COMMUNICATION',
);
export const setUsageApplication = createEffect('SET_USAGE_APPLICATION');
export const setUsageApplicationSummary = createEffect(
  'SET_USAGE_APPLICATION_SUMMARY',
);
export const setUsage = createEffect('SET_USAGE');

export const setIntegrations = createEffect('SET_INTEGRATIONS');
export const addIntegration = createEffect('ADD_INTEGRATION');
export const deleteIntegration = createEffect('DELETE_INTEGRATION');
